import { Route, Switch, BrowserRouter } from "react-router-dom";
import React from "react";
import "./App.css";
import ConfigurationPage from "./Pages/ConfigurationPage";
import SummaryPage from "./Pages/SummaryPage";
import OrderSubmitPage from "./Pages/OrderSubmitPage";
import SalesPartnerPage from "./Pages/SalesPartnerPage";
import { generalConfigurationStore } from "./Stores/GeneralConfigurationStore";
import ScrollTop from "./Components/ScrollTop";
import { observer } from "mobx-react";
import { APIClient, IAPIClientOptions, IAPITarget } from "network-stapler";

type Props = {
	productId: string;
	langLocal: string;
	baseName: string;
	baseUrl: string;
};

@observer
class App extends React.Component<Props> {
	apiClientDynamicBaseUrl: APIClient;
	options: IAPIClientOptions;

	constructor(props: Props) {
		super(props);

		this.options = {
			baseUrl: this.props.baseUrl,
			throwOnErrorStatusCodes: true,
			stubResponse: false, // set to false to use real network requests
			stubResponseTime: 1000,
			defaultHeaders: (target: any) => {
				const headers = target.headers || {};

				if (!target.headers || !target.headers.Accept) {
					headers.Accept = "application/json";
				}

				if (target.body instanceof FormData === false) {
					headers["Content-Type"] = "application/json";
				} else if (target.body instanceof FormData) {
					delete headers["Content-Type"];
				}

				return {
					...headers,
				};
			},
			// by default, encode all body params as JSON String
			defaultEncodeBody: (target: IAPITarget) => {
				return JSON.stringify(target.body || {});
			},
		};

		this.apiClientDynamicBaseUrl = new APIClient(this.options);
	}

	componentDidMount() {
		generalConfigurationStore.loadConfigWithProductId(this.apiClientDynamicBaseUrl, this.props.productId, this.props.langLocal);
	}

	render() {
		return (
			<div className="App">
				{this.props.baseName && (
					<BrowserRouter basename={this.props.baseName}>
						<ScrollTop />
						<Switch>
							<Route exact path="/" component={() => <ConfigurationPage />} />
							<Route exact path="/summary" component={() => <SummaryPage />} />
							<Route exact path="/sales-partner" component={() => <SalesPartnerPage apiClientDynamicBaseUrl={this.apiClientDynamicBaseUrl} langLocal={this.props.langLocal} />} />
							<Route exact path="/submit" component={() => <OrderSubmitPage apiClientDynamicBaseUrl={this.apiClientDynamicBaseUrl} />} />
							<Route
								path="/"
								component={() => (
									<div>
										<h2>404</h2>
									</div>
								)}
							/>
						</Switch>
					</BrowserRouter>
				)}
			</div>
		);
	}
}

export default App;
